import React, { useEffect } from "react";
import LicenseSetupContent from "layout/licenseSetup/LicenseSetupContent";
import ModalsHolder from "layout/discovery/ModalsHolder";
import LicenseSetupNavBar from "layout/licenseSetup/LicenseSetupNavBar";
import { useDispatch } from "react-redux";
import { clearJobQueue } from "slices/app/appSlice";

const LicenseSetup = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearJobQueue());
  }, [dispatch]);

  return (
    <div className="license_setup">
      <ModalsHolder />
      <LicenseSetupNavBar />
      <LicenseSetupContent />
    </div>
  );
};

export default LicenseSetup;
